import {notifyVerificationRequired} from '@utils/verification';
import {fetchBaseQuery} from '@reduxjs/toolkit/dist/query/react';
import {FetchBaseQueryArgs} from '@reduxjs/toolkit/dist/query/fetchBaseQuery';
import {devBaseUrl, prodBaseUrl} from '../api';
import type {BaseQueryFn, FetchArgs, FetchBaseQueryError} from '@reduxjs/toolkit/query';

interface BaseQueryParams {
    baseUrl: string;
    prepareHeaders: FetchBaseQueryArgs['prepareHeaders'],
}

export const baseQuery = ({baseUrl, prepareHeaders}: Partial<BaseQueryParams> = {}): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
    const request = fetchBaseQuery({
    baseUrl: baseUrl || (process.env.NODE_ENV === 'development' ? devBaseUrl : prodBaseUrl),
    prepareHeaders: prepareHeaders || ((headers, {getState}) => {
        const {token} = (getState() as any).app.token || {token: ''};
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        headers.set('Accept', 'application/json');
        headers.set('Content-Type', 'application/json');
        return headers;
    })
});
    return async (args, api, options) => {
        const result = await request(args, api, options);
        if (result.error) notifyVerificationRequired(result.error.status, result.error.data);
        return result;
    };
};
